var setBodyMargin = function() {
    if( $('html').hasClass('has_cookie_policy_banner') ) {
        var height = $("#cookie_policy_banner").height();

        if (height) {
            $("body").css("margin-bottom", height + 41);
        }
    }
};

$(window).on("resize", setBodyMargin), setBodyMargin();
